import { render, staticRenderFns } from "./MasterTimeVoyage.vue?vue&type=template&id=815690d0&scoped=true&"
import script from "./MasterTimeVoyage.vue?vue&type=script&lang=js&"
export * from "./MasterTimeVoyage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "815690d0",
  null
  
)

export default component.exports